<!-- <div class="css-Grupo_Radiobutton grupo_radiobutton">
    <p class="css-Etiqueta etiqueta">{{descripcion_etiqueta}}</p>
    <div class="css-Lista_items lista_items">
        <div class="css-Item_Radiobutton-2 item_radiobutton" *ngFor="let opcion of opciones">
            <div class="css-Padding_Radiobutton-2 padding_radiobutton cursor-pointer">
                <input id="rd{{opcion.value}}" type="radio"
                    class="css-input_radio_Radiobutton input_radio_radiobutton cursor-pointer"
                    name="comp_item_radiobutton" value="{{opcion.value}}" [(ngModel)]="modelValue"
                    (ngModelChange)="onInputChange($event)">
            </div>
            <label class="css-label_etiqueta_radio-2 label_etiqueta_radio cursor-pointer"
                for="rd{{opcion.value}}">{{opcion.texto}}</label>
        </div>
    </div>
</div> -->

<div class="css-radiobutton_default-1 radiobutton_default">
    <p class="css-etiqueta_radiobutton-1 etiqueta_radiobutton">{{descripcion_etiqueta}}</p>
    <div class="css-lista_radiobutton-1 lista_radiobutton">
        <!-- Instance of sub-component comp-item-radiobutton-default -->
        <div class="css-item_radiobutton_default-4 item_radiobutton_default" *ngFor="let opcion of opciones">
            <div class="css-Radio_default-4 radio_default">
                <input id="rd{{opcion.value}}" type="radio"
                    class="css-input_radio_Radiobutton_default-4 input_radio_radiobutton_default"
                    value="{{opcion.value}}" [(ngModel)]="modelValue" (ngModelChange)="onInputChange($event)">
            </div>
            <label for="rd{{opcion.value}}" class="css-label_Radiobutton_default-4 label_radiobutton_default">
                <p data-wcfid="texto_opcion_radiobutton"
                    class="css-texto_opcion_Radiobutton-4 texto_opcion_radiobutton">{{opcion.texto}}</p>
                <p *ngIf="texto_complementario" data-wcfid="texto_complementario_radiobutton"
                    class="css-texto_complementario_Radiobutton-4 texto_complementario_radiobutton">
                    {{texto_complementario}}</p>
            </label>
        </div>
    </div>
    <div data-wcfid="mensaje_error_radiobutton" data-css-switch="estado_error"
        class="css-mensaje_error_radiobutton-1 mensaje_error_radiobutton">
        <p data-wcfid="texto_mensaje_error_radiobutton"
            class="css-texto_mensaje_error_radiobutton-1 texto_mensaje_error_radiobutton">{{mensaje_error}}</p>
    </div>
</div>